import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './global.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

document.getElementById("cards").onmousemove = e => {
    for (const card of document.getElementsByClassName("card")) {
        const rect = card.getBoundingClientRect(),
            x = e.clientX - rect.left,
            y = e.clientY - rect.top;
        card.style.setProperty('--mouse-x', `${x}px`);
        card.style.setProperty('--mouse-y', `${y}px`);
    }
}



// WEBPACK FOOTER //
// ./src/index.js